export default __webpack_public_path__ + "static/media/logo.f9168c77.svg";